import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {baseUrl, ipAddress, userName} from '../Univ';
function WorkerHome() {
    const userId = localStorage.getItem("user_id");
    const [worker, setWorker] = useState(null);
    const [workerId, setWorkerId] = useState(null);
    const [jobs, setJobs] = useState([]);
    const [available, setAvailable] = useState(false);
    const [radius, setRadius] = useState(0);
    const [appliedJobs, setAppliedJobs] = useState([]);
// ---------------- GET WORKER PROFILE ----------------
    useEffect(() => {
        if (!userId) return;
        axios.get(
            baseUrl +
            "worker-profile/" +
            userId +
            "/"
        )
            .then((res) => {
                console.log(
                    "Worker Profile Response:",
                    res.data
                );
                if (res.data.length > 0) {
                    const profile =
                        res.data[0];
                    setWorker(profile);
                    setWorkerId(
                        profile.id
                    );
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, [userId]);
// ---------------- FETCH APPLIED JOBS ----------------
    useEffect(() => {
        if (!workerId) return;
        axios.get(
            baseUrl + "apply/"
        )
            .then((res) => {
                const applied =
                    res.data
                        .filter(
                            (a) =>
                                a.worker?.id ===
                                workerId
                        )
                        .map(
                            (a) =>
                                a.requirement?.id
                        );
                console.log(
                    "Applied Jobs:",
                    applied
                );
                setAppliedJobs(
                    applied
                );
            })
            .catch((err) => {
                console.log(err);
            });
    }, [workerId]);
// ---------------- FETCH JOBS ----------------
    const fetchJobs = () => {
        if (!worker) return;
        axios.get(
            baseUrl +
            "requirements/"
        )
            .then((res) => {
                const filtered =
                    res.data

                        // Active Jobs Only
                        .filter(
                            (r) =>
                                r.status === 1
                        )

                        // Hide Already Applied Jobs
                        .filter(
                            (r) =>
                                !appliedJobs.includes(
                                    r.id
                                )
                        )

                        // Pincode Radius Filter
                        .filter((r) => {
                            const workerPrefix =
                                String(
                                    worker.pincode
                                ).substring(
                                    0,
                                    3
                                );
                            const jobPrefix =
                                String(
                                    r.pincode
                                ).substring(
                                    0,
                                    3
                                );
                            if (
                                workerPrefix !==
                                jobPrefix
                            ) {
                                return false;
                            }
                            const workerSuffix =
                                Number(
                                    String(
                                        worker.pincode
                                    ).substring(3)
                                );
                            const jobSuffix =
                                Number(
                                    String(
                                        r.pincode
                                    ).substring(3)
                                );
                            return (
                                Math.abs(
                                    workerSuffix -
                                    jobSuffix
                                ) <= radius
                            );
                        });
                console.log(
                    "FILTERED JOBS",
                    filtered
                );
                setJobs(
                    filtered
                );
            })
            .catch((err) => {
                console.log(err);
            });
    };
// ---------------- LOAD JOBS ----------------
    useEffect(() => {
        if (available) {
            fetchJobs();
        } else {
            setJobs([]);
        }
    }, [
        available,
        radius,
        worker,
        appliedJobs
    ]);
// ---------------- TOGGLE ----------------
    const handleToggle = (
        e
    ) => {
        setAvailable(
            e.target.checked
        );
    };
// ---------------- APPLY JOB ----------------
    const handleEnroll = (
        job
    ) => {
        if (!workerId) {
            Swal.fire(
                "Error",
                "Worker profile not loaded",
                "error"
            );
            return;
        }
        const fd =
            new FormData();
        fd.append(
            "worker",
            workerId
        );
        fd.append(
            "requirement",
            job.id
        );
        fd.append(
            "status",
            "1"
        );
        fd.append(
            "addedby",
            userName
        );
        fd.append(
            "ip_add",
            ipAddress
        );
        axios.post(
            baseUrl +
            "apply/",
            fd
        )
            .then(() => {
                Swal.fire(
                    "Success",
                    "Applied Successfully",
                    "success"
                );
                // Immediately mark as applied
                setAppliedJobs(
                    (prev) => [
                        ...prev,
                        job.id
                    ]
                );
            })
            .catch((err) => {
                console.log(
                    err.response?.data
                );
                Swal.fire(
                    "Error",
                    "Something Went Wrong",
                    "error"
                );
            });
    };
    return (
        <section className="container mt-4">

            <div className="page-header">

                <h3>
                    Worker Dashboard
                </h3>

                <small>
                    Find Nearby Jobs & Manage Availability
                </small>

            </div>

            {/* WORKER PROFILE */}

            {worker && (
                <div className="card app-profile-card mb-4">

                    <div className="card-body">

                        <div className="d-flex justify-content-between align-items-center flex-wrap">

                            <div>

                                <h4 className="fw-bold mb-2">

                                    👨‍🌾 {worker.name}

                                </h4>

                                <p className="mb-1">

                                    📞 {worker.mobile}

                                </p>

                                <p className="mb-1">

                                    📍 Pincode : {worker.pincode}

                                </p>

                                <p className="mb-0">

                                    🛠 {worker.work_type}

                                </p>

                            </div>

                            <div className="text-center">

                                <h2 className="text-success fw-bold">

                                    {jobs.length}

                                </h2>

                                <small>

                                    Jobs Available

                                </small>

                            </div>

                        </div>

                    </div>

                </div>
            )}

            {/* AVAILABILITY SWITCH */}

            <div className="card app-card mb-4">

                <div className="app-card-body">

                    <div className="d-flex justify-content-between align-items-center flex-wrap">

                        <div>

                            <h5 className="mb-1">

                                Availability Status

                            </h5>

                            <small className="text-muted">

                                Enable to receive nearby jobs

                            </small>

                        </div>

                        <div className="form-check form-switch">

                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                checked={available}
                                onChange={handleToggle}
                                style={{
                                    width: "60px",
                                    height: "28px",
                                    cursor: "pointer"
                                }}
                            />

                        </div>

                    </div>

                </div>

            </div>

            {/* SEARCH RADIUS */}

            {available && (
                <div className="card app-card mb-4">

                    <div className="app-card-body">

                        <div className="d-flex justify-content-between mb-2">

                            <strong>
                                Search Radius
                            </strong>

                            <span className="badge bg-primary">

            {radius} KM

          </span>

                        </div>

                        <input
                            type="range"
                            min="0"
                            max="50"
                            value={radius}
                            onChange={(e) =>
                                setRadius(
                                    Number(e.target.value)
                                )
                            }
                            className="form-range"
                        />

                    </div>

                </div>
            )}

            {/* JOBS */}

            <div className="row">

                {available && jobs.length === 0 && (
                    <div className="alert alert-warning">

                        No Jobs Found Within Selected Radius

                    </div>
                )}

                {jobs.map((job) => {
                    const applied =
                        appliedJobs.includes(job.id);
                    return (
                        <div
                            key={job.id}
                            className="col-lg-4 col-md-6 mb-4"
                        >

                            <div className="card app-card h-100">

                                <div className="app-card-header">

                                    🌱 {job.crop_type}

                                </div>

                                <div className="app-card-body">

                                    <p>

                                        <strong>
                                            🌾 Land Size :
                                        </strong>
                                        {" "}
                                        {job.land_size}
                                        {" "}
                                        {job.land_unit}

                                    </p>

                                    <p>

                                        <strong>
                                            📍 Location :
                                        </strong>
                                        {" "}
                                        {job.location}

                                    </p>

                                    <p>

                                        <strong>
                                            📮 Pincode :
                                        </strong>
                                        {" "}
                                        {job.pincode}

                                    </p>

                                    <p>

                                        <strong>
                                            💰 Budget :
                                        </strong>

                                        <span
                                            style={{
                                                color: "#198754",
                                                fontWeight: "bold",
                                                fontSize: "18px"
                                            }}
                                        >
                  {" "}
                                            ₹{job.budget}
                </span>

                                    </p>

                                </div>

                                <div className="app-card-footer">

                                    <button
                                        className={`btn w-100 fw-bold ${
                                            applied
                                                ? "btn-secondary"
                                                : "btn-action"
                                        }`}
                                        disabled={applied}
                                        onClick={() =>
                                            handleEnroll(job)
                                        }
                                    >

                                        {applied
                                            ? "✓ Already Applied"
                                            : "🚀 Apply Now"}

                                    </button>

                                </div>

                            </div>

                        </div>
                    );
                })}

            </div>

        </section>
    );
}
export default WorkerHome;